import {
  FETCH_MEMBERS,
} from "../../actions/types";

const initialState = {
  items: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_MEMBERS:
      return {
        ...state,
        items: action.payload
      };
      
    default:
      return state;
  }
}
